// extracted by mini-css-extract-plugin
export default {"canvas":"StarField_canvas__2y6xQ"};